import React from 'react';
import PropTypes from 'prop-types';
import Selector from 'react-select';
import { connect } from 'react-redux';

import 'react-date-picker/index.css';
import { MultiMonthView, MonthView } from 'react-date-picker'
import moment from 'moment';

import {findMaps} from 'actions';

require('react-datepicker/dist/react-datepicker.css');

class MapSelectorContainer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			fetching_maps : false,
			current_maps : [],
			screen_size : ''
		}

		this.default_date_range = [];

		this.handleSearchMaps = this.handleSearchMaps.bind(this);
		this.renderMap= this.renderMap.bind(this);
	}

	handleSearchMaps() {
		this.setState({fetching_maps : true});
		if(!this.refs.calendar.state.range || this.refs.calendar.state.range.length < 2) {
			this.props.dispatch(findMaps({
				startDate : this.default_date_range[0],
				endDate : this.default_date_range[1]
			}, (maps) => {
				if(!maps) {
					console.log('error getting maps')
					this.setState({fetching_maps : false});
				}
				else {
					this.setState({
						current_maps : maps,
						fetching_maps : false
					})
				}
			}))
		}
		else {
			this.props.dispatch(findMaps({
				startDate : this.refs.calendar.state.range[0],
				endDate : this.refs.calendar.state.range[1]
			}, (maps) => {
				if(!maps) {
					console.log('error getting maps')
					this.setState({fetching_maps : false});
				}
				else {
					this.setState({
						current_maps : maps,
						fetching_maps : false
					})
				}
			}))
		}
	}

	renderMap(map, index) {
		let storm_date;
		if(map.properties.storm_date) {
			let storm_array = map.properties.storm_date.split('-');
			let day = storm_array[2].substr(0, 2);
			storm_date = storm_array[1] + '/' + day + '/' + storm_array[0];
		}
		else
			storm_date = '';

		let cities = (map.properties.cities.length > 0) ? map.properties.cities : [];
		let title = (map.properties.title !== undefined) ? map.properties.title : '';

		let enabled = (
			this.props.users.tmp_user &&
			this.props.users.tmp_user.purchased_maps &&
			this.props.users.tmp_user.purchased_maps.find(users_map => {
				return users_map === map._id
			}) !== undefined) ? true : false;

		return (
			<tr key={index}>
				<td>{index + 1}</td>
				<td>{storm_date}</td>
				<td>
				{(()=>{
					if(cities.length > 1)
						return cities[0] + '...'
					else
						return cities[0]
				})()}
				</td>
				<td>{title}</td>
				<td>
					<div className='checkbox-custom checkbox-default'>
						<input
							type='checkbox'
							checked={enabled}
							name='purchased_maps'
							id={map._id}
							onChange={this.props.handleChange}
						/>
						<label htmlFor={map._id} />
					</div>
				</td>
			</tr>
		)
	}

	componentWillMount() {
		const now = Date.now();
		const hour = 1000 * 60 * 60;
	  const day = 24 * hour;

	  const one_week = now + day * 7;
	  this.default_date_range = [now, one_week];
	}

	componentDidMount() {
	  const resizeWindow = () => {
	  	const width = $(window).width();

	  	if(width < 992) {
	  		this.setState({screen_size : 'small'});
	  	}
	  	else {
	  		this.setState({screen_size : 'large'});
	  	}
	  };

	  $(window).on('resize.map-selector-container', resizeWindow);
	  resizeWindow();
	}
	componentWillUnmount() {
		$(window).off('resize.map-selector-container'); //Turn off listener.
	}
	render() {
		return (
			<div id='map-selector-container'>
				<div>
					<h5>Select Date Range To Search for a Map</h5>
					{(() => {
						if(this.state.screen_size === 'large')
							return (
								<MultiMonthView
									ref='calendar'
									defaultRange={this.default_date_range}
									dateFormat='MM/DD/YYYY'
									isDatePicker={true}
								/>
							)
						else
							return (
								<MonthView
									ref='calendar'
									defaultRange={this.default_date_range}
									dateFormat='MM/DD/YYYY'
									isDatePicker={true}
								/>
							)
					})()}

				</div>
				<div className='row'>
					<div
						className='btn btn-primary map-search-button'
						onClick={this.handleSearchMaps}>
						{this.state.fetching_maps ?
							<i
								className="fa fa-spinner fa-spin fa-2x fa-fw"
								style={{margin : 'auto'}}
							/> :
							`Search Maps`}
					</div>
				</div>
				{(() => {
					if(this.state.current_maps.length > 0) {
						return (
							<section className='panel'>
								<header className='panel-heading'>
									<h2 className='panel-title'>Available Maps</h2>
								</header>
								<div className='panel-body'>
									<div className='table-responsive'>
										<table className='table mb-none'>
											<thead>
												<tr>
													<th>#</th>
													<th>Storm Date</th>
													<th>Cities</th>
													<th>Title</th>
													<th>Enabled</th>
												</tr>
											</thead>
											<tbody>
												{this.state.current_maps.map(this.renderMap)}
											</tbody>
										</table>
									</div>
								</div>
							</section>
						)
					}
					else{
						return (
							<h5>No Maps within the date range</h5>
						)
					}
				})()}
			</div>
		)
	}
}

export default connect(state => state)(MapSelectorContainer);



// WEBPACK FOOTER //
// ./src/browser/components/users/mapSelector/mapSelectorContainer.js